<template>
  <!--v-select--
      v-model="selected"
      :items="items"
      :variant="useGlobalSetting().globalTextVariant"
      item-title="displayName"
      item-value="name"
      label="Wähle einen Benutzer"
  >
    <template v-slot:prepend-item>
      <v-list-item-title class="text-center font-weight-bold">
        Auswahl eines Benutzers
      </v-list-item-title>
      <v-divider></v-divider>
    </template>

    <template v-slot:item="{ props, item }">
      <v-list-item
          :subtitle="item.raw.name"
          :title="item.raw.displayName"
          v-bind="props">
        <template v-slot:prepend>
          <v-avatar class="outline">
          </v-avatar>
        </template>
      </v-list-item>
    </template>
    <template v-slot:selection="{ item }">
      <v-avatar :class="`outline mr-2`" size="25">
      </v-avatar>
      <span>{{ item.raw.displayName }}</span>
    </template>
  </v-select


      density="compact"
      rounded="lg"


  -->

  <v-select
      v-model="selected"
      :items="items"
      :item-title="itemTitle"
      :item-value="itemValue"
      :label="label"
      :variant="useGlobalSetting().globalTextVariant"
      :multiple="multiple"
      :chips="multiple"
      :closable-chips="multiple"
      :rules="multiple ? [v => v.length > 0 || 'Mindestens ein Mitarbeiter erforderlich'] : []"
      class="mb-3"
  >
    <template v-slot:prepend-item>
      <v-list-item-title class="text-center font-weight-bold px-4 py-2">
        Mitarbeiter auswählen
      </v-list-item-title>
      <v-divider/>
    </template>
    <template v-slot:item="{ props: itemProps, item }">
      <v-list-item v-bind="itemProps" :title="item.raw[itemTitle]" :subtitle="item.raw.id">
        <template v-slot:prepend>
          <v-avatar size="32" color="grey-lighten-3">
            <v-icon icon="mdi-account" size="18"/>
          </v-avatar>
        </template>
      </v-list-item>
    </template>
    <template v-slot:selection="{ item }">
      <v-avatar size="32" color="grey-lighten-3">
        <v-icon icon="mdi-account" size="18"/>
      </v-avatar>
      <span>{{ item.raw[itemTitle] }}</span>
    </template>
  </v-select>
</template>

<script lang="ts" setup>
import {getUserList} from "@/types/Order";
import {onMounted, ref} from "vue";
import {useGlobalSetting} from "@/lib/utils";

const selected = defineModel<any | any[]>()

defineProps({
  variant: {
    type: String,
    default: "outlined"
  },
  required: {
    type: Boolean,
    default: false
  },
  itemTitle: {
    type: String,
    default: "full_name",
  },
  itemValue: {
    type: String,
    default: "id",
  },
  label: {
    type: String,
    default: "Benutzer wählen",
  },
  multiple: {
    type: Boolean,
    default: false,
  }
})

const items = ref<any[]>([]);

onMounted(async () => {
  items.value = await getUserList()
});
</script>
